export default __webpack_public_path__ + "static/media/ummi-icon.da5c1f26.gif";